export const ROUTE_MAP: Record<string, string> = {
  '/': '/',
  '/hakkimizda': '/about',
  '/about': '/hakkimizda',
  '/hizmetlerimiz': '/services',
  '/services': '/hizmetlerimiz',
  '/projelerimiz': '/projects',
  '/projects': '/projelerimiz',
  '/blog': '/blog',
  '/sss': '/faq',
  '/faq': '/sss',
  '/iletisim': '/contact',
  '/contact': '/iletisim',
  '/gizlilik-politikasi': '/privacy-policy',
  '/privacy-policy': '/gizlilik-politikasi',
  '/kullanim-sartlari': '/terms-of-use',
  '/terms-of-use': '/kullanim-sartlari',
};

export const getAlternateRoute = (currentPath: string, targetLang: 'tr' | 'en'): string => {
  let newPath = currentPath;

  if (targetLang === 'en' && !currentPath.startsWith('/en')) {
    // TR -> EN
    if (currentPath.startsWith('/projelerimiz/')) {
      newPath = '/en/projects/' + currentPath.split('/')[2];
    } else if (currentPath.startsWith('/blog/')) {
      newPath = '/en/blog/' + currentPath.split('/')[2];
    } else {
      newPath = '/en' + (ROUTE_MAP[currentPath] || currentPath);
    }
  } else if (targetLang === 'tr' && currentPath.startsWith('/en')) {
    // EN -> TR
    const pathWithoutEn = currentPath.substring(3) || '/';
    if (pathWithoutEn.startsWith('/projects/')) {
      newPath = '/projelerimiz/' + pathWithoutEn.split('/')[2];
    } else if (pathWithoutEn.startsWith('/blog/')) {
      newPath = '/blog/' + pathWithoutEn.split('/')[2];
    } else {
      newPath = ROUTE_MAP[pathWithoutEn] || pathWithoutEn;
    }
  }

  // Ensure trailing slash logic consistency if needed, usually we don't have trailing slash except for root.
  if (newPath === '/en/') newPath = '/en';
  return newPath;
};
